import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../../utils/api';
import { formatBlogDate } from '../../utils/blogUtils';
import { useHyphenate } from '../../hooks/useHyphenate';
import Spinner from '../../components/Spinner/Spinner';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import BackLink from '../../components/BackLink/BackLink';
import BlogPostContent from '../../components/BlogPostContent/BlogPostContent';
import '../CatalogItemPage/CatalogItemPage.css';
import './BlogPostPage.css';

const BlogPostPage = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const hyphenate = useHyphenate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      setLoading(true);
      const res = await apiFetch(`/api/public/blog/${id}`, {
        headers: { Locale: i18n.language },
      });
      setPost(res.ok ? await res.json() : null);
      setLoading(false);
    };
    fetchPost();
  }, [id, i18n.language]);

  if (loading) return <Spinner />;

  return (
    <article className="catalog-item-page blog-post-page">
      <Breadcrumb items={[
        { label: t('blog.title'), to: '/blog' },
        ...(post ? [{ label: post.title }] : []),
      ]} />

      <BackLink to="/blog" label={t('blog.backToBlog')} />

      {post ? (
        <>
          <time className="catalog-item-category-label" dateTime={post.publishedAt}>
            {formatBlogDate(post.publishedAt, i18n.language)}
          </time>
          <h1 className="catalog-item-title">{hyphenate(post.title)}</h1>
          {post.image && <img src={post.image} alt={post.title} className="blog-post-image" />}
          <hr className="catalog-item-divider" />
          <BlogPostContent sections={post.sections} />
        </>
      ) : (
        <p>{t('blog.notFound')}</p>
      )}
    </article>
  );
};

export default BlogPostPage;
